import moment from 'moment-timezone';
import { getUserTimezone } from 'utils/timezone';

export const ruleToDateObj = (rule) => {
    let _value = new Date();
    var currentDay = _value.getDay();
    var distance = rule?.day_of_week - currentDay;
    _value.setUTCDate(_value.getDate() + distance);
    _value.setUTCHours(parseInt(rule?.time?.split(":")?.[0]));
    _value.setUTCMinutes(parseInt(rule?.time?.split(":")?.[1]));
    _value.setUTCMilliseconds(0);
    return _value;
}

/** Convert a rule (UTC day_of_week + time "HH:mm") to a native Date whose local values match the user's timezone. */
export const ruleToUserTzDate = (rule, user) => {
    const tz = getUserTimezone(user);
    const utcHour = parseInt(rule?.time?.split(":")?.[0]);
    const utcMin = parseInt(rule?.time?.split(":")?.[1]);
    const m = moment.utc().day(rule?.day_of_week).hour(utcHour).minute(utcMin).second(0).millisecond(0).tz(tz);
    return new Date(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());
}

/** Convert a native Date (user tz wall-clock from time picker) back to UTC day_of_week + time for saving. */
export const userTzDateToRuleUTC = (date, user) => {
    const tz = getUserTimezone(user);
    const m = moment.tz({
        year: date.getFullYear(), month: date.getMonth(), day: date.getDate(),
        hour: date.getHours(), minute: date.getMinutes()
    }, tz).utc();
    return {
        day_of_week: m.day(),
        time: `${('0' + m.hours()).slice(-2)}:${('0' + m.minutes()).slice(-2)}`
    };
}